var _style, _path, _path2, _path3, _path4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSetup(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 248 248",
    style: {
      enableBackground: "new 0 0 248 248"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:#FFFFFF;}\n\t.st3{opacity:0.4;fill:url(#SVGID_3_);}\n\t.st4{opacity:0.4;fill:url(#SVGID_4_);}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.3146,
    y1: 96.9008,
    x2: 67.2517,
    y2: 96.8886
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0034,
    style: {
      stopColor: "#846BFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7A0BE2"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.304,96.824c-0.007,0.052-0.007,0.103-0.007,0.148v-0.148H67.304z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.0194,
    y1: 136.7152,
    x2: 195.4873,
    y2: 145.7305
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0034,
    style: {
      stopColor: "#1575D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    style: {
      stopColor: "#155BD1"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M180.489,97.164v57.943c0.007,0.148,0.007,0.295,0,0.443v0.162h-0.007c-0.162,1.491-1.314,3.019-3.425,4.237 l-45.432,26.226c-4.163,2.406-10.459,2.665-14.069,0.583l-47.831-27.613c-1.624-0.937-2.421-2.2-2.428-3.513V97.37 c0.096,1.233,0.901,2.399,2.428,3.285l47.831,27.613c3.609,2.082,9.906,1.816,14.069-0.583l45.432-26.233 C179.197,100.22,180.348,98.67,180.489,97.164z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M180.488,97.157c-0.134,1.505-1.295,3.064-3.43,4.298l-45.432,26.229c-4.164,2.403-10.463,2.666-14.069,0.584 l-47.831-27.615c-1.532-0.886-2.33-2.051-2.426-3.281v-0.397c-0.004-0.05,0-0.099,0.008-0.153c0.134-1.505,1.291-3.064,3.43-4.294 l13.386-7.728l2.991-1.727l29.052-16.774c4.168-2.407,10.463-2.666,14.069-0.584l30.519,17.618l3.19,1.841l14.126,8.156 C179.828,94.342,180.618,95.729,180.488,97.157z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 49.1088,
    y1: 137.8005,
    x2: 218.0291,
    y2: 149.6545
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0045,
    style: {
      stopColor: "#1575D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9989,
    style: {
      stopColor: "#1575D1"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.307,85.795v76.188c0.01,0.194,0.01,0.388,0,0.582v0.214h-0.01c-0.214,1.961-1.728,3.97-4.503,5.571 l-59.737,34.484c-5.474,3.164-13.753,3.504-18.499,0.767l-62.892-36.308c-2.135-1.233-3.183-2.892-3.193-4.62V86.067 c0.126,1.621,1.184,3.154,3.193,4.319l62.892,36.308c4.746,2.737,13.025,2.388,18.499-0.767l59.737-34.493 C196.609,89.813,198.123,87.775,198.307,85.795z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.6642,
    y1: 115.685,
    x2: -4.9351,
    y2: 49.0059
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0034,
    style: {
      stopColor: "#1575D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0887,
    style: {
      stopColor: "#1575D1"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1575D1"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M198.508,85.743c-0.176,1.979-1.703,4.028-4.511,5.651l-59.738,34.488c-5.475,3.159-13.758,3.506-18.5,0.769 L52.868,90.339c-2.014-1.165-3.064-2.697-3.19-4.315v-0.522c-0.005-0.065,0-0.13,0.01-0.201c0.176-1.979,1.698-4.028,4.511-5.646 l17.6-10.161l3.933-2.27l38.199-22.056c5.48-3.164,13.758-3.506,18.5-0.769l40.128,23.166l4.194,2.421l18.575,10.724 C197.639,82.041,198.679,83.864,198.508,85.743z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetup);
export default __webpack_public_path__ + "static/media/setup.d75c5be7c361874be7c3a3c81c5f171f.svg";
export { ForwardRef as ReactComponent };